// extracted by mini-css-extract-plugin
module.exports = {"actions":"ApprovalFlows_actions__2YqU9","action":"ApprovalFlows_action__25c_t","header":"ApprovalFlows_header__2Pc9A","active":"ApprovalFlows_active__3Q8ez"};